<template>
  <Card
    :class="$style.card"
    data-test-id="RecentOS__widgetCard"
  >
    <HeadingExtraSmall
      hasMargin
      :text="widgetNames.newOSReleases"
      weight="bold"
    >
      {{ widgetNames.newOSReleases }}
      <ButtonLink
        :class="$style.link"
        data-test-id="RecentOS__viewDetails"
        text="View OS Releases"
        @click="handleViewOsReleasesLink('View Details',$options.routes.deviceOverview)"
      />
    </HeadingExtraSmall>
    <GridAuto minWidth="15rem">
      <Card
        v-for="osName in osNames"
        :key="osName"
        :class="$style.innerCard"
        :data-test-id="`RecentOS__${osName}`"
      >
        <CountVertical
          :class="$style.countVertical"
          :count="osReleases[osName]"
          countSize="large"
          :label="recentOsReleasesNames[osName]"
        />
      </Card>
      <Card
        :class="$style.innerCard"
        data-test-id="RecentOS__patchPolicies "
      >
        <InputLabel
          :class="$style.labelButton"
          text="Patch Policies"
        />
        <Button
          :class="$style.labelButton"
          data-test-id="RecentOS__patchPoliciesButton "
          text="manage"
          textCase="capitalize"
          type="primary"
          @click="handleButtonClick('Patch Policies', $options.routes.osPatchManagement)"
        />
      </Card>
    </GridAuto>
  </Card>
</template>

<script>
import {
  Button,
  ButtonLink,
  Card,
  CountVertical,
  GridAuto,
  HeadingExtraSmall,
  InputLabel,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts, ItemTypeRoutes,
} from 'client/util/Constants';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import SegmentEventMixin from 'client/HomePageV2/mixins/SegmentEventMixin';
import SoftwareApi from 'client/api/v2/SoftwareApi';
import Util from 'client/util/Util';
import moment from 'moment';

const routes = {
  deviceOverview: ItemTypeRoutes[ItemTypeConsts.deviceOverview],
  osPatchManagement: ItemTypeRoutes[ItemTypeConsts.osPatchManagement],
};
const { recentOsReleasesNames, widgetTypes, widgetNames } = HomeWidgetConsts;
const { newOsReleases } = widgetTypes;

export default {
  name: 'RecentOSReleasesWidget',

  routes,

  components: {
    Button,
    ButtonLink,
    Card,
    CountVertical,
    GridAuto,
    HeadingExtraSmall,
    InputLabel,
  },

  mixins: [SegmentEventMixin],

  data: () => ({
    newOsReleases,
    recentOsReleasesNames,
    osReleases: {
      macOS: 0,
      windows: 0,
      ubuntu: 0,
    },
    osNames: ['windows', 'macOS', 'ubuntu'],
    totalCount: 0,
    widgetNames,
  }),

  async created() {
    await this.fetchReleases();
  },

  methods: {
    fetchReleases() {
      const releaseDate = new Date();
      releaseDate.setDate(releaseDate.getDate() - 15);
      const formattedDate = moment(releaseDate).format('YYYY-MM-DD');
      return Promise.all(this.osNames.map(osName => {
        const filterParameter = {
          osName,
          limit: 1,
          date: formattedDate,
          sort: '-version',
        };
        return SoftwareApi.fetchOsReleasesForWidget(filterParameter).then(res => {
          this.osReleases[osName] = res.totalCount;
          this.totalCount += res.totalCount;
        });
      }));
    },

    handleButtonClick(buttonText, url) {
      this.triggerButtonClickedHandler(
        'Recent OS release Patch Policies Button clicked',
        'Home Page',
        'Recent OS release widget',
        url,
        buttonText,
      );
      Util.redirect(url);
    },

    handleViewOsReleasesLink(text, url) {
      this.triggerLinkClickedHandler(
        'Recent OS release View OS Releases Buttonlink clicked',
        'Recent OS release widget',
        url,
        text,
      );
      Util.redirect(url);
    },
  },
};
</script>
<style module scoped>
@value (cardShadow1) from '~css/shadows.css';

.card {
  border-radius: var(--jc-border-radius-small);
  box-shadow: cardShadow1;
}

.innerCard {
  border-radius: var(--jc-border-radius-small);
}

.countVertical:not(.legacyOverride):not(.legacyOverride) {
  padding-left: 4.5rem;
}

.labelButton:not(.legacyOverride):not(.legacyOverride) {
  font-size: var(--jcBody);
  margin-left: 3rem;
}

.link:not(.legacyOverride):not(.legacyOverride) {
  float: right;
}
</style>
